import lodash from 'lodash';
export const MuduEmojis = [
    {
        value: '[em_1]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/1.png',
    },
    {
        value: '[em_2]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/2.png',
    },
    {
        value: '[em_3]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/3.png',
    },
    {
        value: '[em_5]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/5.png',
    },
    {
        value: '[em_6]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/6.png',
    },
    {
        value: '[em_10]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/10.png',
    },
    {
        value: '[em_16]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/16.png',
    },
    {
        value: '[em_19]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/19.png',
    },
    {
        value: '[em_20]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/20.png',
    },
    {
        value: '[em_21]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/21.png',
    },
    {
        value: '[em_37]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/37.png',
    },
    {
        value: '[em_63]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/63.png',
    },
    {
        value: '[em_65]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/65.png',
    },
    {
        value: '[em_69]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/69.png',
    },
    {
        value: '[em_71]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/71.png',
    },
    {
        value: '[em_72]',
        icon: '//static.mudu.tv/assets/img-console/activity/face/72.png',
    },
];
const publicPath = process.env.APP_ENV == 'release' ? 'https://fos.lenovo.com' : '';
const base = publicPath + location.pathname;
export const MyEmojis = [
    {
        'icon': base + 'emoj/chijing.png',
        'value': '[\u5403\u60ca]',
        'label': '吃惊',
    },
    {
        'icon': base + '/emoj/dacall.png',
        'value': '[\u6253call]',
        'label': '打Call',
    },
    {
        'icon': base + '/emoj/daku.png',
        'value': '[\u6253\u54ed]',
        'label': '大哭',
    },
    {
        'icon': base + '/emoj/daxiao.png',
        'value': '[\u5927\u7b11]',
        'label': '大笑',
    },
    {
        'icon': base + '/emoj/dianzan.png',
        'value': '[\u70b9\u8d5e]',
        'label': '点赞',
    },
    {
        'icon': base + '/emoj/ganga.png',
        'value': '[\u5c34\u5c2c]',
        'label': '尴尬',
    },
    {
        'icon': base + '/emoj/guzhang.png',
        'value': '[\u9f13\u638c]',
        'label': '鼓掌',
    },
    {
        'icon': base + '/emoj/jiaoao.png',
        'value': '[\u9a84\u50b2]',
        'label': '骄傲',
    },
    {
        'icon': base + '/emoj/koubi.png',
        'value': '[\u62a0\u9f3b]',
        'label': '吃惊',
    },
    {
        'icon': base + '/emoj/ku.png',
        'value': '[\u9177]',
        'label': '酷',
    },
    {
        'icon': base + '/emoj/liwu.png',
        'value': '[\u793c\u7269]',
        'label': '礼物',
    },
    {
        'icon': base + '/emoj/shengqi.png',
        'value': '[\u751f\u6c14]',
        'label': '生气',
    },
    {
        'icon': base + '/emoj/songhua.png',
        'value': '[\u9001\u82b1]',
        'label': '送花',
    },
    {
        'icon': base + '/emoj/weixiao.png',
        'value': '[\u5fae\u7b11]',
        'label': '吃惊',
    },
    {
        'icon': base + '/emoj/weiqu.png',
        'value': '[\u59d4\u5c48]',
        'label': '委屈',
    },
    {
        'icon': base + '/emoj/wuyu.png',
        'value': '[\u65e0\u8bed]',
        'label': '无语',
    },
    {
        'icon': base + '/emoj/xiao.png',
        'value': '[\u7b11]',
        'label': '笑',
    },
    {
        'icon': base + '/emoj/xiaoku.png',
        'value': '[\u7b11\u54ed]',
        'label': '笑哭',
    },
    {
        'icon': base + '/emoj/xin.png',
        'value': '[\u5fc3]',
        'label': '心',
    },
    {
        'icon': base + '/emoj/xingxingyan.png',
        'value': '[\u661f\u661f\u773c]',
        'label': '星星眼',
    },
    {
        'icon': base + '/emoj/yihuo.png',
        'value': '[\u7591\u60d1]',
        'label': '疑惑',
    },
];
export const Emojis = [...MuduEmojis, ...MyEmojis];
export const FormatFace = function (html) {
    if (html) {
        if (html.msg_type == '40') {
            html = `<img class="live-chat-wordImg live-chat-img" src="${html.src}" alt="icon">`;
        }
        html = lodash.toString(html);
        const fas = lodash.uniq(html.match(/\[([\s\S]+?)\]/g));
        fas.map((value) => {
            const face = lodash.find(Emojis, ['value', value]);
            if (face) {
                const reg = new RegExp(`(\\${value})`, 'g');
                html = lodash.replace(html, reg, `<span class="live-chat-face"><img class="live-chat-img" src="${face.icon}" alt="icon"></span>`);
            }
        });
    }
    return html;
};
